var styles = {
  "RollupMenu": "Online-Store-UI-RollupMenu_3vyj3",
  "Header": "Online-Store-UI-RollupMenu__Header_117ib"
};

export { styles as default };
